import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Game} from '../../domain/game';
import {GameService} from '../game.service';
import {FOTOVRAGENSET, NORMALEVRAGENSET, QUIZVRAGENSET, STELLINGSET} from '../game-data';

@Component({
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})

export class GameComponent implements OnInit {

  loading = false;
  chosenPlayer = 0;
  game: Game = {
    players: [
      {name: 'Placeholder', age: null, anxChoice: null, anxChoiceAfter: null, avatarIcon: 0, gender: null, wisdomCards: 0}
    ],
    stellingScores: [{stellingID: 999, stellingScore: 'placeholder'}],
  };

  showStartgameDialog = false;
  showEndgameDialog = false;
  showVraagScherm = false;
  showStellingScherm = false;
  showQuizScherm = false;
  showEndquestions = false;
  showWisdomcardScherm = false;
  showMysterycardsScherm = false;
  mysterycardsActive = false;
  showGameDialog = false;
  dobbelsteenPlaceholder = 'dobbelsteen 0.png';
  welkeDobbelsteen: string;

  // GAMEKEUZE VRAAG
  normaleVragenset = NORMALEVRAGENSET;
  fotoVragenset = FOTOVRAGENSET;
  vraagSoort = 'leeg';
  randomWelkeVraag = 0;
  randomWelkeFotovraag = 0;
  gekozenNormalevragen = [];
  gekozenFotovragen = [];

  // GAMEKEUZE STELLING
  stellingSet = STELLINGSET;
  randomStelling = 0;
  gekozenStellingen = [];

  // GAMEKEUZE QUIZ
  quizvragenSet = QUIZVRAGENSET;
  randomQuizvraag = 0;
  gekozenQuizvragen = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gameService: GameService) {
  }

  ngOnInit() {
    this.welkeDobbelsteen = this.dobbelsteenPlaceholder;

    this.loading = true;
    this.gameService.getGame(this.activatedRoute.snapshot.params.id).subscribe(game => {

      this.loading = false;
      this.showStartgameDialog = true;

      this.game = game;
      console.log('Game = ', game);
    }, () => {
      console.log('Handle game not found');
    });
  }

  nextPlayer() {
    this.chosenPlayer += 1;
    if (this.chosenPlayer >= this.game.players.length) {
      this.chosenPlayer = 0;
      this.game.numberOfRounds += 1;
      console.log('Rounds : ', this.game.numberOfRounds, 'myst : ', this.mysterycardsActive);

      // CHECK OP MYSTERYCARD DIALOG
      if ((this.game.numberOfRounds > 10) && (!this.mysterycardsActive)) {
        this.showMysterycardsScherm = true;
        this.mysterycardsActive = true;
      }
    }
    this.welkeDobbelsteen = this.dobbelsteenPlaceholder;
  }

  dobbelen() {
    // CHECK OF ER EEN WISDOMCARD KOMT
    if (this.randowWisdomCard()) {
      this.game.players[this.chosenPlayer].wisdomCards += 1;
      this.showWisdomcardScherm = true;
    } else {
      // ZO NIET DAN DOBBELEN
      this.welkeDobbelsteen = 'dobbelgif.gif';
      setTimeout(() => {
        this.gooi();
      }, 1000);
      return this.welkeDobbelsteen;
    }
  }

  gooi() {
    this.welkeDobbelsteen = 'dobbelsteen ' + (Math.floor(Math.random() * 6) + 1) + '.png';
    console.log(this.game.players);
  }

  randowWisdomCard() {
    // kans op wisdomcard per speler
    if (this.game.players[this.chosenPlayer].wisdomCards >= 5) {
      // console.log('Speler heeft al 5 wijsheidskaarten via app');
      return false;
    } else {
      const random = (Math.floor(Math.random() * 7));
      const cardYes = (random === 1);
      // console.log('Uitkomst = ', random, 'cardYes = ', cardYes);
      return cardYes;
    }
  }

  gameKeuze(keuze) {
    switch (keuze) {
      case 'vraag': {
        const randomSoortVraag = (Math.floor(Math.random() * 11)); // kans op foto 20%
        if (randomSoortVraag > 2) {
          this.randomWelkeVraag = (Math.floor(Math.random() * this.normaleVragenset.length));
          if (this.randomWelkeVraag in this.gekozenNormalevragen) {
            // AL GEWEEST
          } else {
            this.vraagSoort = 'normale vraag';
            this.gekozenNormalevragen.push(this.randomWelkeVraag);
            this.showVraagScherm = true;
          }
        } else {
          this.randomWelkeFotovraag = (Math.floor(Math.random() * this.fotoVragenset.length));
          if (this.randomWelkeFotovraag in this.gekozenFotovragen) {
            // AL GEWEEST
          } else {
            this.vraagSoort = 'fotovraag';
            this.gekozenFotovragen.push(this.randomWelkeFotovraag);
            this.showVraagScherm = true;
          }
        }
      }
                    break;
      case 'stelling': {
        this.randomStelling = (Math.floor(Math.random() * this.stellingSet.length));
        if (this.randomStelling in this.gekozenStellingen) {
          // AL GEWEEST
        } else {
          this.gekozenStellingen.push(this.randomStelling);
          this.showStellingScherm = true;
        }
      }
                       break;
      case 'quizvraag': {
        this.randomQuizvraag = (Math.floor(Math.random() * this.quizvragenSet.length));
        if (this.randomQuizvraag in this.gekozenQuizvragen) {
          // AL GEWEEST
        } else {
          this.gekozenQuizvragen.push(this.randomQuizvraag);
          this.showQuizScherm = true;
        }
      }
    }
  }

  handelKeuzeSchermAf($event) {
    if ($event != null) {
      this.showVraagScherm = false;
      this.showStellingScherm = false;
      this.showQuizScherm = false;
      this.showWisdomcardScherm = false;
      this.showMysterycardsScherm = false;
      if ($event === true) {
        // TERUG UIT VRAAG EN QUIZ
        this.nextPlayer();
      } else {
        // TERUG UIT STELLING
        this.game.stellingScores.push($event);
        this.gameService.updateGame(this.game).subscribe(game => {
          this.game = game;
        });
        this.nextPlayer();
      }
    } else {
      this.showVraagScherm = false;
      this.showStellingScherm = false;
      this.showQuizScherm = false;
      this.showWisdomcardScherm = false;
      this.showMysterycardsScherm = false;
    }
  }

  handelKeuzeDialogAf($event) {
    if ($event != null) {
      // GA DOOR
      this.gameService.updateGame(this.game).subscribe(game => {
        this.game = game;
      });
      this.showGameDialog = false;
      this.showEndquestions = true;
    } else {
      // TERUG
      this.showGameDialog = false;
      this.showStartgameDialog = false;
    }
  }

}
